<template>
  <base-jin-nang-panel title="锦囊申请" :back-href="JinNangIndexRoute">
    <template v-slot:bodyContent>
      <el-form :model="applyForm" class="apply-form">
        <div class="form-row mb30">
          <div class="row-label">锦囊名称:</div>
          <div class="row-input">
            <el-input
              class="width366px"
              v-model="applyForm.name"
              placeholder=""
              maxlength="10"
            ></el-input>
            <span class="name-counter">{{ nameTip }}</span>
          </div>
        </div>
        <div class="form-row mb10">
          <div class="row-label">期望定价:</div>
          <div class="row-multi-input">
            <div
              v-for="(item, index) in priceList"
              :key="index"
              @click="priceSelected(index)"
              :class="{
                btnSel: true,
                'btnSel-selected': index === currentPriceIndex
              }"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
        <div class="form-row mb10">
          <div class="row-label">类型:</div>
          <div class="row-multi-input">
            <div
              v-for="(item, index) in levelList"
              :key="index"
              @click="levelSelected(index)"
              :class="{
                btnSel: true,
                'btnSel-selected': index === currentLevelIndex
              }"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
        <div class="form-row mb30">
          <div class="row-label">操作风格(多选):</div>
          <div class="row-multi-input bgfa">
            <el-checkbox-group
              class="style-container"
              v-model="applyForm.style"
            >
              <div
                v-for="(item, index) in styleList"
                :key="index"
                class="style-cell"
              >
                <el-checkbox :label="item.text" name="style"></el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
        <div class="form-row mb40">
          <div class="row-label">简介:</div>
          <div class="row-input">
            <el-input
              type="textarea"
              placeholder="请输入锦囊简介"
              v-model="applyForm.remark"
              maxlength="300"
              show-word-limit
              class="remark"
              rows="9"
            >
            </el-input>
          </div>
        </div>
        <div class="form-row">
          <div class="row-label"></div>
          <div class="row-input">
            <el-button
              :class="{
                subBtn: true
              }"
              @click="applyJinNang"
              type="button"
              >提交</el-button
            >
          </div>
        </div>
      </el-form>
    </template>
  </base-jin-nang-panel>
</template>

<script>
import BaseJinNangPanel from '../BaseJinnangPanel/BaseJinNangPanel'
import { jinNangApply } from '@/api/AuthorJinNang'

export default {
  name: 'jinNangApplication',
  components: { BaseJinNangPanel },
  props: {},
  data() {
    return {
      applyForm: {
        name: '',
        style: [],
        remark: '',
        price: 788,
        amountType: 4, // 100万
        level: 1
      },
      styleList: [
        { text: '波段操作', value: 1 },
        { text: '中短线', value: 2 },
        { text: '中长线', value: 3 },
        { text: '基本面', value: 4 },
        { text: '趋势交易', value: 5 },
        { text: '量化投资', value: 6 },
        { text: '价值成长', value: 7 },
        { text: '热点题材', value: 8 }
      ],
      levelList: [
        { text: '稳健型', value: 1, index: 0 },
        { text: '积极型', value: 2, index: 1 },
        { text: '激进型', value: 1, index: 2 }
      ],
      currentLevelIndex: 0,
      priceList: [
        { text: '788元/月', value: 788, index: 0 },
        { text: '988元/月', value: 988, index: 1 },
        { text: '1248元/月', value: 1248, index: 2 }
      ],
      currentPriceIndex: 0,
      rules: {
        name: [
          { required: true, message: '请输入锦囊名称', trigger: 'blur' },
          {
            min: 1,
            max: 10,
            message: '锦囊名称不能超过10个字符',
            trigger: 'blur'
          }
        ],
        price: [
          { required: true, message: '请选择期望定价', trigger: 'change' }
        ],
        level: [{ required: true, message: '请选锦囊类型', trigger: 'change' }],
        style: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个操作风格',
            trigger: 'change'
          }
        ],
        remark: [
          { required: true, message: '请输入锦囊简介', trigger: 'blur' },
          {
            min: 1,
            max: 10,
            message: '锦囊简介不能超过300个字符',
            trigger: 'blur'
          }
        ]
      },
      JinNangIndexRoute: '/excl-author/jinnang'
    }
  },
  computed: {
    nameTip() {
      return this.applyForm.name.length + '/10'
    }
  },
  methods: {
    async applyJinNang() {
      if (!this.formvalidate()) {
        return
      }
      this.applyForm.style = this.applyForm.style.map(
        a => this.styleList.findIndex(b => b.text === a) + 1
      )

      const data = await jinNangApply({
        ...this.applyForm
      })
      if (data && data.result.code === 0) {
        this.$router.push('/excl-author/jinnang/apply-result')
      } else {
        this.$message.error(data.result.msg || '申请失败')
      }
    },
    priceSelected(index) {
      this.applyForm.price = this.priceList[index].value
      this.currentPriceIndex = index
    },
    levelSelected(index) {
      this.applyForm.level = this.levelList[index].value
      this.currentLevelIndex = index
    },
    formvalidate() {
      if (!this.applyForm.name) {
        this.$message.error('请输入锦囊名称')
        return false
      } else if (!this.applyForm.price) {
        this.$message.error('请选择期望定价')
        return false
      } else if (!this.applyForm.style || this.applyForm.style.length === 0) {
        this.$message.error('请选择操作风格')
        return false
      } else if (!this.applyForm.level) {
        this.$message.error('请选择类型')
        return false
      } else {
        return true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.apply-form {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

.form-row {
  display: flex;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
}
.row-label {
  text-align: center;
  line-height: 44px;
  letter-spacing: 0px;
  color: #858585;
  margin-right: 20px;
  width: 135px;
  flex: none;
}

.width366px {
  width: 366px;
}
.name-counter {
  margin-left: 20px;
  color: #858585;
}
.row-input {
  flex: auto;
}
.row-multi-input {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.row-input-wrapper {
  flex: auto;
  display: flex;
  justify-content: space-between;
  margin: 8px 0px;
}
.mb30 {
  margin-bottom: 30px;
}
.mt20 {
  margin-top: 20px;
}
.mb40 {
  margin-bottom: 40px;
}

.mb10 {
  margin-bottom: 10px;
}

.btnSel {
  width: 140px;
  height: 44px;
  line-height: 44px;
  border-radius: 22px;
  border: solid 1px #ebebeb;
  text-align: center;
  margin-right: 20px;
  cursor: pointer;
  margin-bottom: 20px;
}
.btnSel-selected {
  background-color: rgba(4, 107, 204, 0.1);
  color: #046bcc;
  border: none;
}

.width200 {
  width: 200px;
}
.bgfa {
  background-color: #fafafa;
}

.style-container {
  width: 430px;
  flex: none;
  display: flex;
  flex-flow: row wrap;
  padding: 8px 0px 30px 30px;
}

.remark {
  width: 460px;
}

.style-cell {
  margin-top: 18px;
  width: 140px;
}

.subBtn {
  width: 180px;
  height: 44px;
  background-color: #046bcc;
  border-radius: 5px;
  font-family: MicrosoftYaHei;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
}
</style>
